/* eslint-disable max-len */
import React from 'react';

import { useDispatch } from 'react-redux';
import { POSCatalogData } from '../../../../../common/libraries/modelViewer/Data/POSCatalogData';
import { CustomAttributesReducer } from '../../../../../Redux/Reducers/CustomAttributesReducer';
import { useAppSelector } from '../../../../../Redux/Store/hooks';

import '../../../../../common/libraries/react/customAttributes/defaultPresentation/customAttributesDefaultPresentation.scss';
import './customAttributes.css';
import { PriceData } from '../../../../../common/libraries/fileFormats/catalog/catalog';
import { ModelConfigurationLinearCustomAttributes } from '../../../../../common/libraries/react/modelConfiguration/modelConfigurationLinearCustomAttributes';
import { CustomAttributeValues, toDTO } from '../../../../../common/libraries/customAttributes/customAttributeValue';
import { Currencies } from '../../../../Util/currencies';

interface ComponentOrderCustomAttributesProps {
  catalog : POSCatalogData,
  priceInfo: number,
  priceData: PriceData[] | undefined,
  lang: string,
}

export function ComponentOrderCustomAttributes({
  catalog,
  priceInfo,
  priceData,
  lang,
} : ComponentOrderCustomAttributesProps) : JSX.Element {

  // Grab the dispatch hook from Redux
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const priceCurrencySymbol = Currencies.getSymbol(priceInfo);

  const { setAllAttributeValues } = CustomAttributesReducer.actions;

  // From the store, get the custom attributes values
  const customAttributesValues = useAppSelector((store) => {
    return store.CustomAttributesReducer.customAttributesValues;
  });

  // TODO PMC Add the required values of change this to the argumtes to a object of type "CustomAttributeValue"
  const onAttributeValueChanged = (attrs: CustomAttributeValues) : void => {

    const dtos = attrs.map((dV) => toDTO(dV));

    if (!dtos) {
      return;
    }
    dispatch(setAllAttributeValues(dtos));
  };

  const customOrderAttributesData = catalog.catalogFileInfo?.orderCustomAttributesDefinitions.attributes;

  return (
    <div>
      {
        catalog.catalogFileInfo
        && catalog.catalogFileInfo.orderCustomAttributesDefinitions
        && catalog.catalogFileInfo.orderCustomAttributesDefinitions.attributes
        && catalog.catalogFileInfo.orderCustomAttributesDefinitions.attributes.length > 0
        && (
          <div
            className="custom-attributes-parent"
          >
            <ModelConfigurationLinearCustomAttributes
              className=""
              sltxFile={undefined}
              selectedOptions={undefined}
              customAttributes={customOrderAttributesData || []}
              customAttributesValues={customAttributesValues}
              priceData={priceData}
              languageSelected={lang}
              changeCustomAttributesHandler={onAttributeValueChanged}
              bCheckForExtras={false}
            />
          </div>
        )
      }
    </div>
  );
}
